var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_478_017058"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16,
    width: 17,
    height: 17,
    rx: 3.5
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,-1,0,33)",
    clipPath: "url(#master_svg0_478_017058)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.009999999776482582
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,16.5L16.5,16.5L16.5,32.5L0.5,32.5L0.5,16.5Z",
    fill: "#202425",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5874900625,21.079306599375C15.0038980625,21.495839599375,15.0038980625,22.171040009374998,14.5874900625,22.587573009375L9.2541570625,27.920906109375C8.8376235625,28.337313609375002,8.162424062500001,28.337313609375002,7.7458906625,27.920906109375L2.4125573625,22.587572609375C1.9836032425,22.173276409375,1.9776453925,21.487770079375,2.3993339525,21.066081999375C2.8210225125,20.644393439375,3.5065288624999997,20.650351519375,3.9208240625,21.079305649375L8.5000238625,25.658506409375L13.0792240625,21.079306599375C13.4957570625,20.662899494375,14.1709570625,20.662899494375,14.5874900625,21.079306599375Z",
    fill: "#4E5969",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 16.5,
    width: 16,
    height: 16,
    rx: 3,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#D1D1D1",
    fill: "none",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/upIcon.eeae7e72359bf43725f7c7609f712c20.svg";
export { ForwardRef as ReactComponent };